export default {
  medications: {
    anyDocumentaion: {
      anyValues: {
        issues: [
          {
            id: 'I-MED-1000',
            domain: 'DMA'
          }
        ]
      }
    },
    medicationConflict: {
      issues: [
        {
          id: 'I-MED-2900',
          domain: 'DMA'
        }
      ]
    },
    code: {
      unDocumented: {
        issues: [
          {
            id: 'I-MED-1100',
            domain: 'DMA'
          }
        ]
      }
    },
    dose: {
      unDocumented: {
        issues: [
          {
            id: 'I-MED-1300',
            domain: 'DMA',
            isDynamic: true,
            dynamicParameters: { Medication: 'display' }
          }
        ]
      }
    },
    understand: {
      issues: [
        {
          id: 'I-MED-2100',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'no'
    },
    obtaining: {
      issues: [
        {
          id: 'I-MED-2200',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'yes'
    },
    paying: {
      issues: [
        {
          id: 'I-MED-2300',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'yes'
    },
    taking: {
      issues: [
        {
          id: 'I-MED-2400',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'no'
    },
    compliant: {
      issues: [
        {
          id: 'I-MED-2500',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'no'
    },
    preference: {
      issues: [
        {
          id: 'I-MED-2600',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'yes'
    },
    sideEffects: {
      issues: [
        {
          id: 'I-MED-2700',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { Medication: 'display' }
        }
      ],
      triggerValue: 'yes'
    }
  },
  immunizations: {
    isExpired: {
      issues: [
        {
          id: 'I-MED-3000',
          domain: 'DMA',
          isDynamic: true,
          dynamicParameters: { ImmunizationType: 'name' }
        }
      ],
      triggerValue: true
    }
  }
}
